import { render, staticRenderFns } from "./dataLtvPirate.vue?vue&type=template&id=22db3a8b&scoped=true&"
import script from "./dataLtvPirate.vue?vue&type=script&lang=js&"
export * from "./dataLtvPirate.vue?vue&type=script&lang=js&"
import style0 from "./dataLtvPirate.vue?vue&type=style&index=0&id=22db3a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db3a8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22db3a8b')) {
      api.createRecord('22db3a8b', component.options)
    } else {
      api.reload('22db3a8b', component.options)
    }
    module.hot.accept("./dataLtvPirate.vue?vue&type=template&id=22db3a8b&scoped=true&", function () {
      api.rerender('22db3a8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/dataLtvPirate.vue"
export default component.exports